import ContentLikeApi from './ContentLikeApi';
export default ContentLikeApi;
